import { Component, Input } from '@angular/core';
import { OmpCalloutIcon, OmpCalloutLayout, OmpHeadingSize, OmpTextAlignment } from '../../../_models';
import {
  OmpAccentStyleOptions,
  OmpCalloutIconOptions,
  OmpCalloutLayoutOptions,
  OmpCalloutToneOptions,
} from '../../order-management-portal.sections';
import { calloutToneColors, OmpSectionSettings } from '..';

@Component({
  selector: 'omp-callout-settings',
  templateUrl: './callout-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpCalloutSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  public textAlignment = OmpTextAlignment;
  public accentStyleOptions = OmpAccentStyleOptions;
  public toneOptions = OmpCalloutToneOptions;
  public layoutOptions = OmpCalloutLayoutOptions;
  public iconOptions = OmpCalloutIconOptions;

  @Input() pageBackground = '';
  @Input() brandVariables: any = {};

  get previewBackground(): string {
    let background = this.pageBackground;
    if (this.data && this.data.display_inside_card && this.data.background_color) {
      background = this.data.background_color;
    }
    return background;
  }

  get usesCustomIcon(): boolean {
    return !!(this.data && this.data.icon_name === OmpCalloutIcon.Custom);
  }

  onToneChange() {
    const colors = calloutToneColors(this.brandVariables, this.data.tone);
    Object.keys(colors).forEach((field) => {
      this.data[field] = colors[field];
    });
    this.change.emit();
  }

  get allowsTextAlignment(): boolean {
    return !!(this.data && this.data.layout !== OmpCalloutLayout.Banner);
  }
}
